import { ValidationService } from 'aspnet-client-validation';

const validation = new ValidationService();

// Custom validator for the server-side [MustBeTrue] attribute. The standard
// [Range(typeof(bool), "true", "true")] pattern emits `data-val-range-min="True"`
// which aspnet-client-validation can't parse as a number — so the field reports
// as invalid even when the checkbox is ticked. [MustBeTrue] emits
// `data-val-mustbetrue="<error message>"` and this provider just checks
// `element.checked` for checkboxes (or the parsed boolean for other inputs).
validation.addProvider('mustbetrue', (value, element) => {
    if (element instanceof HTMLInputElement && element.type === 'checkbox') {
        return element.checked;
    }
    return value === 'true' || value === 'True';
});

validation.bootstrap();

// Defer showing validation error messages until the field has been blurred at least
// once (or the form has been submitted). aspnet-client-validation validates on every
// keystroke and there's no built-in "validate on blur" option, so we mark each error
// span as `is-touched` after the matching input loses focus — paired CSS hides any
// span that hasn't been touched. The validation itself still runs in real time, so
// once a field has been touched the error updates as the user corrects their input.
const markFieldTouched = (input) => {
    if (!input || !input.name) return;
    const errSpan = document.querySelector(`[data-valmsg-for="${CSS.escape(input.name)}"]`);
    if (errSpan) errSpan.classList.add('is-touched');
};

// blur doesn't bubble, so listen in capture phase
document.addEventListener('blur', (e) => {
    if (e.target?.matches?.('[data-val="true"]')) {
        markFieldTouched(e.target);
    }
}, true);

// On submit, reveal every error message on the form (matches the typical
// "validate everything when the user tries to submit" pattern).
document.addEventListener('submit', (e) => {
    if (e.target instanceof HTMLFormElement) {
        e.target.querySelectorAll('[data-val="true"]').forEach(markFieldTouched);
    }
}, true);

// Reveal any errors that were already on the page at load (e.g. server-side
// ModelState errors returned after a failed POST). Without this, the user would
// re-land on the form after a server rejection but see no errors because the
// spans haven't been blurred yet on this fresh page load.
document.querySelectorAll('span[data-valmsg-for].field-validation-error').forEach((span) => {
    span.classList.add('is-touched');
});
